import Event from './project/Event';
import { Option, Some } from 'tsoption';
import * as _ from 'lodash';

class TreeNode {
  public name: string;
  public parent: string | null;
  public component: Event;
  public outcome: string;
  public probability: number;
  public work_estimate: Option<number>;
  public custom_estimate: Option<number>;
  public title: string;
  public children: Array<TreeNode>;

  constructor(
    name: string,
    parent: string | null,
    component: Event,
    outcome: string,
    probability: number,
    workEstimate: number | null,
    customEstimate: number | null,
    children: Array<TreeNode>
  ) {
    let prob = (_.isNumber(probability) ? probability : 1.0);

    this.name = name;
    this.parent = parent;
    this.component = component;
    this.outcome = outcome;
    this.probability = prob;
    this.work_estimate = (workEstimate) ? Option.of(workEstimate) : Option.of(null);
    this.custom_estimate = (customEstimate) ? Option.of(customEstimate) : Option.of(null);
    this.children = children;
    this.title = component.title + ": " + this.outcome + " (" + prob * 100.0 + " %)";
  }
}

export default TreeNode;



// WEBPACK FOOTER //
// ./src/models/TreeNode.ts